export default __webpack_public_path__ + "static/media/5.015587c3.jpg";